import styled from 'styled-components';

export const Container = styled.div`
  @media only screen and (max-width: 768px) {
    .fc .fc-toolbar {
      display: block;
    }
  }
`;
